import cls from 'classnames';
import Button from 'components/common/Button';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import React from 'react';
import { sendGAEvent } from 'utils/ga';
import LogoHomecredit from '../images/logoHomeCredit.png';
import { goToApp } from '../utils';
import s from './style.css';

class NoOffer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    sendGAEvent(
      'Visit_Page',
      'Existing_Customer_No_Offer_Page',
      'ACL_0BOD_Existing_Customer_No_Offer',
    );
  }

  render() {
    return (
      <div className={s.container}>
        <div className={s.logoWrapper}>
          <img src="images/logoHome.svg" className={s.logo} alt="HomeCredit" />
        </div>
        <div className={s.titleWrapper}>
          Rất tiếc, chưa có khoản vay phù hợp với bạn tại thời điểm này
        </div>
        <div className={s.contentWrapper}>
          <div className={s.boxWrapper}>
            <img src={LogoHomecredit} alt="logoHome" />
            <div>
              <p className={cls(s.title, s.noSpace)}>
                Home Credit Tài Chính Online
              </p>
              <span className={s.paragraph}>
                Khám phá các ưu đãi độc quyền trên ứng dụng Home Credit.
              </span>
            </div>
          </div>
        </div>
        <div className={s.actionWrapper}>
          <Button
            type="submit"
            onClick={() => goToApp('https://hcv.onelink.me/ausQ/aclnooffer')}
          >
            KHÁM PHÁ APP HOME CREDIT
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(NoOffer);
